import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { News } from '../../models/news.model';
import EpicNewsCard from '../../RifoDesign/EpicNewsCard/epic.news.card.vue';
import EpicNewsPopular from '../../RifoDesign/EpicNewsPopular/epic.news.popular.vue';
import EpicFooter from '../../RifoDesign/EpicFooter/epic.footer.vue';
import EpicNewsListHeader from '../../RifoDesign/EpicNewsListHeader/epic.news.list.header.vue';
import { NewsListDelegate } from '../../services/DataDelegate/NewsDelegate/news.list.delegate';
import EpicHeaderBannerText from '../../RifoDesign/EpicHeaderBannerText/epic.header.banner.text.vue';
import EpicStandardLayout from '../../layout/EpicStandard/epic.standard.layout.vue';
import { CommonConfig } from '../../configs/config.common';
// import gql from 'graphql-tag';

@Component({
    components: {
        EpicNewsCard,
        EpicNewsPopular,
        EpicFooter,
        EpicNewsListHeader,
        EpicHeaderBannerText,
        'layout': EpicStandardLayout
    },
    //  apollo: {
    //     allTags() {
    //         return {
    //             query: gql`{
    //                 allTags {
    //                     name
    //                 }
    //             }`,
    //             prefetch: true
    //         };
    //     }
    // },
    // data() {
    //     return {
    //         allTags: null
    //     };
    // }
})
export default class EpicNewsListPage extends Vue {
    public newsListDelegate = new NewsListDelegate();
    public pageNo: number = 1;
    public newsData: News[] = [];
    public haveMore: boolean = false;
    public loading: boolean = false;
    public configs = new CommonConfig();
    public mobileBannerUri = `${this.configs.rifoDesignAssetsUrl}/epic-header/bg5.jpg`;
    @Watch('$route', { immediate: true, deep: true })
    public async onRouteChange(val: any, oldVal: any) {
        this.loading = true;
        this.pageNo = 1;
        this.$store.state.newsList.selectType = this.$route.params.type;
        const result = await this.newsListDelegate.getNewsList(this.$store.state.newsList.selectType, this.pageNo);
        this.newsData = result.data;
        this.haveMore = result.pageNo < result.totalPage;
        this.loading = false;
    }

    public async created() {
    }
    public async loadMore() {
        this.haveMore = false;
        this.pageNo++;
        const result = await this.newsListDelegate.getNewsList(this.$store.state.newsList.selectType, this.pageNo);
        const newsList = result.data;
        this.haveMore = result.pageNo < result.totalPage;
        this.newsData = this.newsData.concat(newsList);
    }
    public async selectType(type: string) {
        this.$store.commit('selectNewsListType', type);
    }
}
